module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "banner"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row d-none d-md-flex align-items-center banner-section"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('h1', {
    staticClass: "heading"
  }, [_vm._v(_vm._s(_vm.getDonationData && _vm.getDonationData.page_header_title))]), _vm._v(" "), _c('p', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.getDonationData && _vm.getDonationData.page_header_description)
    }
  }), _vm._v(" "), _c('a', {
    staticClass: "donate-button-link",
    attrs: {
      "href": _vm.getDonationData && _vm.getDonationData.page_header_button_redirect_link,
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "donate-button",
    on: {
      "click": function($event) {
        _vm.donate()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.getDonationData && _vm.getDonationData.page_header_button_text) + "\n                    ")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 image-grid"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 mb-3 dogs-restling"
  }, [_c('img', {
    attrs: {
      "src": _vm.getDonationData && _vm.getDonationData.page_header_image_2,
      "alt": "Dogs resting"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-3 two-dog-cuddling"
  }, [_c('img', {
    attrs: {
      "src": _vm.getDonationData && _vm.getDonationData.page_header_image_1,
      "alt": "Two dogs cuddling"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-7 cat-care"
  }, [_c('img', {
    attrs: {
      "src": _vm.getDonationData && _vm.getDonationData.page_header_image_3,
      "alt": "Cat being cared for"
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex d-md-none"
  }, [_c('div', {
    staticClass: "col-12 image-grid ml-2"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 mb-2 dogs-restling"
  }, [_c('img', {
    attrs: {
      "src": _vm.getDonationData && _vm.getDonationData.page_header_image_2,
      "alt": "Dogs resting"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 mb-3 two-dog-cuddling"
  }, [_c('img', {
    attrs: {
      "src": _vm.getDonationData && _vm.getDonationData.page_header_image_1,
      "alt": "Two dogs cuddling"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-8 cat-care"
  }, [_c('img', {
    ref: "imageToScroll",
    attrs: {
      "src": _vm.getDonationData && _vm.getDonationData.page_header_image_3,
      "alt": "Cat being cared for"
    }
  })])])]), _vm._v(" "), _c('div', {
    ref: "headingToScroll",
    staticClass: "col-12 heading",
    attrs: {
      "id": "campain-info"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.getDonationData && _vm.getDonationData.page_header_title))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 description"
  }, [_c('p', {
    staticClass: "description",
    domProps: {
      "innerHTML": _vm._s(_vm.getDonationData && _vm.getDonationData.page_header_description)
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "main-slider-container"
  }, [_c('div', {
    staticClass: "slider-container"
  }, [_c('h2', {
    staticClass: "slider-heading"
  }, [_vm._v(_vm._s(_vm.getDonationData && _vm.getDonationData.main_content_1_title))]), _vm._v(" "), _c('p', {
    staticClass: "slider-content"
  }, [_vm._v(_vm._s(_vm.getDonationData && _vm.getDonationData.main_content_1_description))]), _vm._v(" "), _c('div', {
    staticClass: "carousel slide",
    attrs: {
      "id": "carouselExampleIndicators",
      "data-bs-ride": "carousel"
    }
  }), _vm._v(" "), _c('carousel', {
    staticClass: "exc-cat-carousel",
    attrs: {
      "perPage": 5,
      "loop": true,
      "mouse-drag": true,
      "autoplay": false,
      "autoplayTimeout": 3000,
      "paginationActiveColor": "#117a7a",
      "paginationColor": "#646769",
      "paginationEnabled": _vm.isDesktop,
      "perPageCustom": [
        [213, 3.5],
        [380, 3.3],
        [420, 3.6],
        [480, 4],
        [768, 4],
        [1200, 4],
        [1920, 4]
      ]
    }
  }, _vm._l((_vm.getDonationData && _vm.getDonationData.main_content_1_crousel_images), function(item, index) {
    return _c('slide', {
      key: index,
      staticClass: "exc-cat-slider"
    }, [_c('a', {
      staticClass: "ml-2 mr-2",
      attrs: {
        "href": item.image_redirect_link,
        "target": "_blank",
        "rel": "noopener noreferrer"
      }
    }, [_c('img', {
      staticClass: "img-fluid",
      attrs: {
        "src": item.image,
        "alt": ("Image " + (index + 1))
      }
    }), _vm._v(" "), _c('img', {
      staticClass: "play-btn",
      attrs: {
        "src": "https://prod-img.thesouledstore.com/static/play.svg",
        "alt": "play"
      }
    })])])
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "container my-3"
  }, [_c('h2', {
    staticClass: "text-center mb-4 donation-heading"
  }, [_vm._v(_vm._s(_vm.getDonationData && _vm.getDonationData.main_content_2_title))]), _vm._v(" "), _c('div', {
    staticClass: "donation-container"
  }, [(_vm.getDonationData && _vm.getDonationData.main_content_2_tabular_description && _vm.getDonationData.main_content_2_tabular_description.length) ? _c('div', {
    staticClass: "donation-header"
  }, [_c('span', [_vm._v(_vm._s(_vm.getDonationData.main_content_2_tabular_description[0].column_1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getDonationData.main_content_2_tabular_description[0].column_2))])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.getDonationData && _vm.getDonationData.main_content_2_tabular_description && _vm.getDonationData.main_content_2_tabular_description.length && _vm.getDonationData.main_content_2_tabular_description.slice(1)), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "donation-row"
    }, [_c('span', [_vm._v(_vm._s(item.column_1))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.column_2))])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "disclaimer"
  }, [_c('p', [_vm._v(_vm._s(_vm.getDonationData && _vm.getDonationData.main_content_2_disclaimer))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.getDonationData && _vm.getDonationData.page_footer_contact_text))])])]), _vm._v(" "), (_vm.getDonationData.page_footer_icons) ? _c('div', {
    staticClass: "container-fluid stats-section"
  }, [_c('div', {
    staticClass: "d-flex flex-wrap justify-content-between"
  }, [(_vm.getDonationData.page_footer_icons[0]) ? _c('div', {
    staticClass: "stat-block stat-adoptions"
  }, [_c('div', {
    staticClass: "stat-icon-number"
  }, [(_vm.getDonationData.page_footer_icons[0].icon_image) ? _c('img', {
    staticClass: "stat-icon",
    attrs: {
      "src": _vm.getDonationData.page_footer_icons[0].icon_image,
      "alt": "icon"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stat-number",
    staticStyle: {
      "color": "#FF0000"
    }
  }, [_vm._v(_vm._s(_vm.getDonationData.page_footer_icons[0].icon_text_1))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-title"
  }, [_vm._v(_vm._s(_vm.getDonationData.page_footer_icons[0].icon_text_2))])]) : _vm._e(), _vm._v(" "), (_vm.getDonationData.page_footer_icons[1]) ? _c('div', {
    staticClass: "stat-block stat-rescues"
  }, [_c('div', {
    staticClass: "stat-icon-number"
  }, [(_vm.getDonationData.page_footer_icons[1].icon_image) ? _c('img', {
    staticClass: "stat-icon",
    staticStyle: {
      "margin-top": "-5px"
    },
    attrs: {
      "src": _vm.getDonationData.page_footer_icons[1].icon_image,
      "alt": "icon"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stat-number",
    staticStyle: {
      "color": "#0C8EFF"
    }
  }, [_vm._v(_vm._s(_vm.getDonationData.page_footer_icons[1].icon_text_1))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-title",
    staticStyle: {
      "margin-top": "5px"
    }
  }, [_vm._v(_vm._s(_vm.getDonationData.page_footer_icons[1].icon_text_2))])]) : _vm._e(), _vm._v(" "), (_vm.getDonationData.page_footer_icons[2]) ? _c('div', {
    staticClass: "stat-block stat-sterilisations"
  }, [_c('div', {
    staticClass: "stat-icon-number"
  }, [(_vm.getDonationData.page_footer_icons[2].icon_image) ? _c('img', {
    staticClass: "stat-icon",
    attrs: {
      "src": _vm.getDonationData.page_footer_icons[2].icon_image,
      "alt": "icon"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "stat-number",
    staticStyle: {
      "color": "#26A502"
    }
  }, [_vm._v(_vm._s(_vm.getDonationData.page_footer_icons[2].icon_text_1))])]), _vm._v(" "), _c('div', {
    staticClass: "stat-title"
  }, [_vm._v(_vm._s(_vm.getDonationData.page_footer_icons[2].icon_text_2))])]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sticky-button"
  }, [_c('a', {
    staticClass: "donate-button-link",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "href": _vm.getDonationData && _vm.getDonationData.page_header_button_redirect_link,
      "target": "_blank"
    }
  }, [_c('button', {
    staticClass: "donate-button",
    on: {
      "click": function($event) {
        _vm.donate()
      }
    }
  }, [_vm._v("\n            " + _vm._s(_vm.getDonationData && _vm.getDonationData.page_header_button_text) + "\n        ")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 logo"
  }, [_c('img', {
    staticClass: "me-3",
    attrs: {
      "src": "https://prod-img.thesouledstore.com/static/WFA.svg",
      "alt": "World For All Logo"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfddf920"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AnimalDonation.vue
// module id = 1004
// module chunks = 113